import { render, staticRenderFns } from "./SocialMediaHouseRules.vue?vue&type=template&id=aef055ce&scoped=true&"
import script from "./SocialMediaHouseRules.vue?vue&type=script&lang=js&"
export * from "./SocialMediaHouseRules.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaHouseRules.vue?vue&type=style&index=0&id=aef055ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef055ce",
  null
  
)

export default component.exports